<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false" >
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('班组名称')" prop="teamName">
                <a-input v-model="model.teamName"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('班组介绍')" prop="teamIntroduce">
                <a-input v-model="model.teamIntroduce"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('组长名称')" prop="leaderId">
                <a-select :placeholder="$t('请选择组长')" v-model="model.leaderId">
                  <a-select-option :value="item.id" v-for="item in personnelList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('组长联系方式')" prop="leaderPhone">
                <a-input v-model="model.leaderPhone"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('组员选择')" prop="ticketsTeamUserList">
                <a-transfer
                    :data-source="transferUser.mockData"
                    :titles="[$t('全部用户'), $t('已选用户')]"
                    :target-keys="transferUser.targetKeys"
                    :selected-keys="transferUser.selectedKeys"
                    :render="item => item.title"
                    :disabled="transferUser.disabled"
                    show-search
                    :list-style="{
                      width: '250px',
                      height: '300px',
                    }"
                    @change="handleTransferUserChange"
                    @selectChange="handleTransferUserSelectChange"
                    @scroll="handleTransferUserScroll"
                  />

                <!-- <a-select mode="multiple" placeholder="请选择组员" v-model="model.ticketsTeamUserList" @change="handleChange">
                  <a-select-option :value="item.userId" :key="item.userId" v-for="item in userList" :disabled="item.disabled">{{item.userName}}</a-select-option>
                </a-select> -->
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  export default {
    // mixins: [JeecgListMixin],
    name: 'ProcessingTeamModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        transferUser:{
          mockData :[],
          oriTargetKeys :[],
          targetKeys :[], // 已选用户
          selectedKeys: [], // 当前被选中项
          disabled: false,
        },
        url: {
          add: "/jeecg-engineering/ticket/ticketsTeam/add",
          edit: "/jeecg-engineering/ticket/ticketsTeam/edit",
          queryById: "/jeecg-engineering/ticket/ticketsTeam/queryById",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
        },
        personnelList: [],
        userList: [],
      }
    },
    computed: {
      validatorRules() {
        return {
          leaderId: [{required:true,message:this.$t('请选择组长'),trigger:'change'}],
          teamName: [{required:true,message:this.$t('请输入班组名称'),trigger:'bulr'}],
          teamIntroduce: [{required:true,message:this.$t('请输入班组介绍'),trigger:'bulr'}],
          leaderPhone: [{required:true,message:this.$t('请输入组长联系方式'),trigger:'bulr'}],
          ticketsTeamUserList:[{
              required: true,
              message: this.$t('请至少选择一个组员'),
              trigger: 'change', // 改为change事件触发
              validator: (rule, value, callback) => {
                if (!value || value.length === 0) {
                  callback(new Error(this.$t('请至少选择一个组员')));
                } else {
                  callback();
                }
              }
          }]
        }
      }
    },
    watch:{
      'model.leaderId':{
        handler(val){
          if(val){
            let params = this.personnelList.find(per=>per.id == val);
            if(params){
              this.$set(this.model,'leaderName',params.name);
              this.$set(this.model,'leaderPhone',params.phone);
            }
            this.model.ticketsTeamUserList = this.model.ticketsTeamUserList&&this.model.ticketsTeamUserList.filter(u=>u!=val);
            this.userList.forEach(item=>{
              if(item.userId == val){
                item.disabled = true;
              }else{
                item.disabled = false;
              }
            });
          }
        }
      }
    },
    methods: {
      getPersonnelList(){
        this.personnelList = [];
        this.userList = [];
        this.transferUser.mockData = [];
        getAction(this.url.userList,{status:1}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.personnelList.push({
                id: item.userId,
                name: item.userName,
                phone: item.userPhone
              });
              this.userList.push({
                userId: item.userId,
                userName: item.userName,
                userPhone: item.userPhone,
              });
              // 用户穿梭框-所有用户数据 
              this.transferUser.mockData.push({
                key: item.userId,
                title: item.userName,
                description: item.userName,
                disabled: false,
              });
            });
          }
        });
      },
      add() {
        this.visible = true;
        this.model = {
          ticketsTeamUserList: []
        };
        this.init();
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        });
        this.getPersonnelList();
      },
      init(){
        this.transferUser = {
          mockData :[],
          oriTargetKeys :[],
          targetKeys :[], // 已选用户
          selectedKeys: [], // 当前被选中项
          disabled: false,
        }
      },
      edit(record) {
        this.init();
        this.model = JSON.parse(JSON.stringify(record));
        this.getPersonnelList();
        getAction(this.url.queryById,{id:this.model.id}).then(res=>{
          if(res.success){
            this.$set(this.model,'ticketsTeamUserList',res.result.inspectionTeamUserIds);
            this.$set(this.transferUser,'targetKeys',res.result.inspectionTeamUserIds);

            // 数据准备好后再显示表单并清空校验
            this.visible = true;
            this.$nextTick(() => {
              this.$refs.form.clearValidate();
            });
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        console.log("当前选择用户数据：",this.model.ticketsTeamUserList);
        
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            
            let params = JSON.parse(JSON.stringify(this.model));
            let list = this.userList.filter(p=>params.ticketsTeamUserList.some(e=>e == p.userId));
            list.unshift({
              userId: params.leaderId,
              userName: params.leaderName,
              userPhone: params.leaderPhone
            });
            params.ticketsTeamUserList = [...list];
            httpAction(httpurl, params, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      handleChange(e){
      this.model.ticketsTeamUserList
      //   // this.model.ticketsTeamUserList = [];
      //   let list = this.userList.filter(p=>e.some(e=>e == p.userId));
      //   // this.model.ticketsTeamUserList = [...list];
        
      //   list.unshift({
      //     userId: this.model.leaderId,
      //     userName: this.model.leaderName,
      //     userPhone: this.model.leaderPhone
      //   });
      //   this.$set(this.model,'ticketsTeamUserList',list)
      },
      handleTransferUserChange(nextTargetKeys, direction, moveKeys) {
        this.transferUser.targetKeys = nextTargetKeys;
        this.model.ticketsTeamUserList = nextTargetKeys;
        this.$refs.form.validateField('ticketsTeamUserList'); // 手动触发校验

        console.log('targetKeys: ', nextTargetKeys);
        console.log('direction: ', direction);
        console.log('moveKeys: ', moveKeys);
      },
      handleTransferUserSelectChange(sourceSelectedKeys, targetSelectedKeys) {
        this.transferUser.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];

        console.log('sourceSelectedKeys: ', sourceSelectedKeys);
        console.log('targetSelectedKeys: ', targetSelectedKeys);
      },
      handleTransferUserScroll(direction, e) {
        console.log('direction:', direction);
        console.log('target:', e.target);
      },
      handleTransferUserDisable(disabled) {
        this.transferUser.disabled = disabled;
      },
    }
  }
</script>